// extracted by mini-css-extract-plugin
module.exports = {"root":"PreviewRoll-styles-module--root--1a2Xv","container":"PreviewRoll-styles-module--container--Odfl_"};